import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { H5View } from '../Typography/H5View';
import { IconComponent } from '../Icons/IconComponent';
import { SimpleButtonView } from '../Buttons/SimpleButtonView';
import { useDirection } from '../../Hooks/UseDirection';
export const DatePickerSelectorView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.datePickerSelector,
    style: {
        container: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            marginHorizontal: -5,
            marginBottom: 33
        },
        icon: {
            paddingVertical: 10,
        },
        iconLeft: {
            paddingEnd: 10
        },
        iconRight: {
            paddingStart: 10
        },
        title: {
            flex: 1,
            textAlign: 'center',
            marginBottom: 0
        },
        iconDisabled: {
            opacity: 0.5
        }
    }
})(({ style, onPrevMonth, onNextMonth, title, date, minDate, maxDate }) => {
    var _a, _b;
    const [dir] = useDirection();
    const disable_prev = useMemo(() => {
        if (date && minDate) {
            const new_date = date.clone();
            new_date.setDate(1);
            const min_date = minDate.clone();
            min_date.setDate(1);
            return new_date.getUnix() <= min_date.getUnix();
        }
        return false;
    }, [date, minDate]);
    const disable_next = useMemo(() => {
        if (date && maxDate) {
            const new_date = date.clone();
            new_date.setDate(1);
            const max_date = maxDate.clone();
            max_date.setDate(1);
            return new_date.getUnix() >= max_date.getUnix();
        }
        return false;
    }, [date, minDate]);
    return (_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.container, dir: 'ltr', children: [_jsx(SimpleButtonView, { hitSlop: 5, containerStyle: Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.icon), style === null || style === void 0 ? void 0 : style.iconLeft), disabledOpacity: (_a = style === null || style === void 0 ? void 0 : style.iconDisabled) === null || _a === void 0 ? void 0 : _a.opacity, onPress: onPrevMonth, disabled: disable_prev, children: _jsx(IconComponent, { name: "si-arrow-left" }) }), _jsx(H5View, { textStyle: style === null || style === void 0 ? void 0 : style.title, dir, children: title }), _jsx(SimpleButtonView, { hitSlop: 5, containerStyle: Object.assign(Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.icon), style === null || style === void 0 ? void 0 : style.iconRight), disable_next && (style === null || style === void 0 ? void 0 : style.iconDisabled)), disabledOpacity: (_b = style === null || style === void 0 ? void 0 : style.iconDisabled) === null || _b === void 0 ? void 0 : _b.opacity, onPress: onNextMonth, disabled: disable_next, children: _jsx(IconComponent, { name: "si-arrow-right" }) })] }));
});
